import Evaluations from '@/views/evaluations/Evaluations.vue'
import EvaluationDetails from '@/views/evaluations/EvaluationDetails.vue'
import ResultExerciseDetails from '@/views/evaluations/results_exercises/Detail.vue'
import EvaluateExecutions from '@/views/evaluations/evaluate_executions/Evaluate.vue'

export default [
  {
    path: 'evaluaciones',
    name: 'evaluations.list',
    component: Evaluations
  },
  {
    path: 'evaluaciones/:id/detalle',
    name: 'evaluations.detail',
    component: EvaluationDetails
  },
  {
    path: 'evaluaciones/:eventId/resultado-binomio/:executionId',
    name: 'detail.exercises',
    component: ResultExerciseDetails
  },
  {
    path: 'evaluaciones/:eventId/evaluar-ejecucion/:executionId',
    name: 'evaluate.executions',
    component: EvaluateExecutions
  }
]
